import { useEffect, useState } from 'react';

const BASE_URL =
	'https://dpjye2wk9gi5z.cloudfront.net/wcsstore/ExtendedSitesCatalogAssetStore/images/catalog/default';

const PLACEHOLDER_IMG = '/images/noImage.png';

const getLastPartOfUrl = (url: string) => url.split('/').pop() || '';

export const getFullImageWithBaseUrl = (url: string) => `${BASE_URL}/${getLastPartOfUrl(url)}`;

interface ProductImgProps {
	fullImageRaw: string;
	render: (src: string) => JSX.Element;
}

export const RenderProductImg: React.FC<ProductImgProps> = ({ fullImageRaw, render }) => {
	const [imageSrc, setImageSrc] = useState(PLACEHOLDER_IMG);

	useEffect(() => {
		const _src = getFullImageWithBaseUrl(fullImageRaw);

		const img = new Image();
		img.onload = () => setImageSrc(_src);
		img.onerror = () => setImageSrc(PLACEHOLDER_IMG);
		img.src = _src;
	}, [fullImageRaw]);

	return render(imageSrc);
};
